// extracted by mini-css-extract-plugin
export default {"backButton":"back-button_backButton__RQojE","backText":"back-button_backText__TP3Ld","chevronIcon":"back-button_chevronIcon__1123Y"};